module.exports = __webpack_public_path__ + "img/magnifying-glass-dollar.87fd780d.svg";